var chunkToChildrenMap = {
	"3675": [
		707,
		9078
	],
	"5666": [
		707,
		9078
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));